var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobileGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 18,
    viewBox: "0 0 12 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 14H6.00833M5.16667 4H6.83333M3.66667 16.5H8.33333C9.26675 16.5 9.7335 16.5 10.09 16.3183C10.4036 16.1586 10.6586 15.9036 10.8183 15.59C11 15.2335 11 14.7667 11 13.8333V4.16667C11 3.23325 11 2.76653 10.8183 2.41002C10.6586 2.09641 10.4036 1.84144 10.09 1.68166C9.7335 1.5 9.26675 1.5 8.33333 1.5H3.66667C2.73325 1.5 2.26653 1.5 1.91002 1.68166C1.59641 1.84144 1.34144 2.09641 1.18166 2.41002C1 2.76653 1 3.23324 1 4.16667V13.8333C1 14.7667 1 15.2335 1.18166 15.59C1.34144 15.9036 1.59641 16.1586 1.91002 16.3183C2.26653 16.5 2.73324 16.5 3.66667 16.5Z",
    stroke: "#127C3E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileGreen);
export default __webpack_public_path__ + "static/media/MobileGreen.f7635297202445efc7b96a9c42fee07a.svg";
export { ForwardRef as ReactComponent };